import React from 'react'
import PropTypes from 'prop-types'
import { bem } from '@argos/utils'

import { MessageButton, MessageInput } from '../components'

const cn = bem({ prefix: 'lc-', block: 'message-form' })

export const MessageForm = ({ newMessage, onChange, onSubmit, focusInput }) => {
  return (
    <form className={`${cn()} lc-controls__form`} data-test={cn()} onSubmit={onSubmit}>
      <MessageInput newMessage={newMessage} onChange={onChange} focusInput={focusInput} />

      <MessageButton />
    </form>
  )
}

MessageForm.propTypes = {
  newMessage: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  focusInput: PropTypes.bool.isRequired,
}

export default MessageForm
